var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00838203 12.9557C0.00838203 9.39194 0.0183256 5.82655 9.70766e-05 2.26283C-0.00487433 1.38105 0.179069 0.63237 1.02089 0.203127C1.86603 -0.22778 2.58026 0.0850038 3.28289 0.599098C8.16481 4.1728 13.055 7.73485 17.9403 11.3052C19.3555 12.3401 19.3538 13.6727 17.932 14.7126C13.0268 18.2946 8.1151 21.8683 3.20997 25.452C2.52226 25.9544 1.80306 26.2056 1.00266 25.793C0.202266 25.3804 -0.00321547 24.655 0.00175594 23.7932C0.0199844 20.1812 0.00838203 16.5676 0.00838203 12.9557Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.215889503cb2e06c4ac068f9e21eb32a.svg";
export { ForwardRef as ReactComponent };